import { api } from "@/api";
import { MutationConfig, MutationResult } from "@/shared/types/base";
import { Usuario } from "@/shared/types/usuario";
import { sleep } from "@/shared/utils";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { ReactNode } from "react";

export async function deleteUsuario(id: string): Promise<Usuario> {
    await sleep(1000);
    const response = await api.delete("usuarios/" + id);
    return response.data;
}

export function useDeleteUsuarioMutation(id: string, mutationConfig: MutationConfig<Usuario> = {}) {
    const queryClient = useQueryClient();
    return useMutation({
        ...mutationConfig,
        mutationFn: async () => await deleteUsuario(id),
        onSuccess: (...args) => {
            mutationConfig.onSuccess && mutationConfig.onSuccess(...args);
            queryClient.invalidateQueries({ queryKey: ["usuarios"] });
        },
    })
}

export interface DeleteUsuarioMutationProps{
    id: string, 
    mutationConfig?: MutationConfig<Usuario>,
    children?:(mutationResult:MutationResult<Usuario>)=>ReactNode
}

export function DeleteUsuarioMutation({
    id,
    children,
    mutationConfig
}:DeleteUsuarioMutationProps){
    const mutationResult = useDeleteUsuarioMutation(id, mutationConfig);
    return children&&children(mutationResult)
}